var _rect, _rect2, _rect3, _line, _rect4, _line2, _rect5, _line3, _rect6, _line4, _rect7, _line5, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileMostPopularPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 784,
  viewBox: "0 0 335 784",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.501953,
  width: 334,
  height: 783,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.002,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63.002,
  width: 295,
  height: 70,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 153.502,
  x2: 20,
  y2: 153.502,
  stroke: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 173.002,
  width: 295,
  height: 70,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 263.502,
  x2: 20,
  y2: 263.502,
  stroke: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 283.002,
  width: 295,
  height: 70,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 373.502,
  x2: 20,
  y2: 373.502,
  stroke: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 393.002,
  width: 295,
  height: 70,
  fill: "#E5E5E5"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 483.502,
  x2: 20,
  y2: 483.502,
  stroke: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 503.002,
  width: 295,
  height: 70,
  fill: "#E5E5E5"
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 593.502,
  x2: 20,
  y2: 593.502,
  stroke: "#110000"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 613.002,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 656.002,
  width: 295,
  height: 28,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 696.002,
  width: 295,
  height: 28,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 736.002,
  width: 295,
  height: 28,
  fill: "#E5E5E5"
})));
export default SvgMobileMostPopularPlaceholder;